// components
import { useState } from "react";
import { Dropdown, DropdownItem } from "shared/components/bulma/dropdown";

// pipes
import { titleCasePipe } from "shared/pipes";

// helpers
import * as helper from "./helper";

const DamageReportDropdown = ({ report, onClick, disabled }) => {
    const [status, setReportStatus] = useState(report.status);

    const dropdownOptions = [];
    const options = ['washing', 'fixed', 'closet'];

    for (const option of options) {
        dropdownOptions.push(
            <DropdownItem key={`key-${1}${option}`} onClick={onClick}>
                {option}
            </DropdownItem>
        )
    }

    const handlePickOption = async (option) => {
        await helper.changeStatus(report, option);
        setReportStatus(option);
    }

    return (
        <Dropdown id={report.barcode} activeOption={titleCasePipe.transform(status)} className="is-fullwidth" disabled={disabled}>
            {options.map((option) => (
                <DropdownItem key={option} onClick={() => handlePickOption(option)}>
                    {titleCasePipe.transform(option)}
                </DropdownItem>
            ))}
        </Dropdown >
    )
};

export { DamageReportDropdown };
